import { Component, Input,Output,EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { AppMainComponent } from 'src/app/app.main.component';
import { ImportserialService } from '../../services/importserial.service';

@Component({
  selector: 'app-addedit-batch',
  templateUrl: './addedit-batch.component.html',
  styleUrl: './addedit-batch.component.scss'
})
export class AddeditBatchComponent implements OnChanges{

  @Input() displayBatchForm: boolean = false;
  @Input() addFlag: boolean = true;
  @Input() batchGroup: any = null;
  @Input() batchData : any =null;
  @Input() batchList : any =[];
  @Output() onSaveBatch = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<any>();
  batchForm: FormGroup;
  addEditBatchdHeader: string = '';
  invalidData: boolean = false;

  constructor(private fb: FormBuilder, private messageService: MessageService, private app: AppMainComponent,
    private importService: ImportserialService) { }

  ngOnChanges(changes: SimpleChanges): void{
    if (changes?.addFlag?.currentValue && changes?.batchGroup?.currentValue && changes?.displayBatchForm?.currentValue) {
      this.addBatch();
    }else if(changes?.batchData?.currentValue && changes?.displayBatchForm?.currentValue){
      this.batchData = changes?.batchData?.currentValue
       this.showEditBatch(this.batchData);
    }
  }

  prepareBatchForm() {
    this.batchForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.user.userId],
      updatedBy: [this.app.companyId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      parentTypeId: [0],
      description: [''],
      groupId: [this.batchGroup?.id],
      organizationId: [this.app.companyId],
      colorCodeId: [0],
      statusId: [1],
      fieldType: ['']
    });
  }

  addBatch() {
    this.prepareBatchForm();
    this.addFlag = true;
    this.invalidData = false;
    this.addEditBatchdHeader = 'Add Batch';
    this.displayBatchForm = true;
  }

  showEditBatch(value) {
    this.prepareBatchForm();
    this.batchForm.patchValue(value);
    this.addEditBatchdHeader = 'Edit Batch';
    this.invalidData = false;
  }


  saveBatch(value) {
    if (this.addFlag) {
      this.invalidData = this.batchList?.find(data => data?.name?.toLowerCase() == value.name?.toLowerCase());
      if (this.invalidData) return;
      this.importService.addBatchList(value).subscribe({
        next: (response) => {
          // Handle response from the API
          this.messageService.add({
            severity: 'success', summary: 'Success',
            detail: 'Batch added successfully...'
          });
          this.onSaveBatch.emit();
        },
        error: (err) => {
          // Handle errors
          this.messageService.add({
            severity: 'error', summary: 'Error',
            detail: `${err.error.Message}`
          });
        }
      });
    } else {
      this.invalidData = this.batchList?.find(data => data?.name?.toLowerCase() == value.name?.toLowerCase() && data?.id !== value.id);
      if (this.invalidData) return;
      this.importService.updateBatchList(value).subscribe({
        next: (response) => {
          // Handle response from the API
          this.onSaveBatch.emit();
          this.messageService.add({
            severity: 'success', summary: 'Success',
            detail: 'Batch updated successfully...'
          });
        },
        error: (err) => {
          // Handle errors
          this.messageService.add({
            severity: 'error', summary: 'Error',
            detail: `${err.error.Message}`
          });
        }
      });
    }
  }

  close(){
    this.onClose.emit();
  }
}
